import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  ProposedPlans = 'ProposedPlans',
}

export const queryKeys = {
  proposedPlans: (clientId: string) => [
    QueryFeature.ProposedPlans,
    QueryKey.ProposedPlans,
    clientId,
  ],
};
